// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__7FJBr","contactContainer":"Contact_contactContainer__JfJc1"};